var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextSize(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "53px",
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/ green / fontsize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Responsive",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-/-Setting-Fonts",
    transform: "translate(-288.000000, -331.000000)",
    fill: "#0082BA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/-green-/-fontsize",
    transform: "translate(275.000000, 318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text-size-button",
    transform: "translate(13.333333, 13.333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4297333,0.123866667 L10.9194667,0.123866667 C4.8984,0.123866667 0,5.02226667 0,11.0433333 L0,41.3058667 C0,47.3269333 4.8984,52.2253333 10.9194667,52.2253333 L41.4297333,52.2253333 C47.4508,52.2253333 52.3492,47.3269333 52.3492,41.3058667 L52.3492,11.0433333 C52.3492,5.02226667 47.4508,0.123866667 41.4297333,0.123866667 Z M48.3492,41.3058667 C48.3492,45.1213333 45.2452,48.2253333 41.4297333,48.2253333 L10.9194667,48.2253333 C7.104,48.2253333 4,45.1213333 4,41.3058667 L4,11.0433333 C4,7.22786667 7.104,4.12386667 10.9194667,4.12386667 L41.4297333,4.12386667 C45.2452,4.12386667 48.3492,7.22786667 48.3492,11.0433333 L48.3492,41.3058667 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8417333,15.1636 L21.9441333,15.1636 C20.8396,15.1636 19.9441333,16.0590667 19.9441333,17.1636 C19.9441333,18.2681333 20.8396,19.1636 21.9441333,19.1636 L26.8929333,19.1636 L26.8929333,35.1856 C26.8929333,36.2901333 27.7884,37.1856 28.8929333,37.1856 C29.9974667,37.1856 30.8929333,36.2901333 30.8929333,35.1856 L30.8929333,19.1636 L35.8417333,19.1636 C36.9462667,19.1636 37.8417333,18.2681333 37.8417333,17.1636 C37.8417333,16.0590667 36.9462667,15.1636 35.8417333,15.1636 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.43,23.9810667 L16.5076,23.9810667 C15.4030667,23.9810667 14.5076,24.8765333 14.5076,25.9810667 C14.5076,27.0856 15.4030667,27.9810667 16.5076,27.9810667 L17.9688,27.9810667 L17.9688,34.958 C17.9688,36.0625333 18.8642667,36.958 19.9688,36.958 C21.0733333,36.958 21.9688,36.0625333 21.9688,34.958 L21.9688,27.9810667 L23.43,27.9810667 C24.5345333,27.9810667 25.43,27.0856 25.43,25.9810667 C25.43,24.8765333 24.5345333,23.9810667 23.43,23.9810667 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSize);
export default __webpack_public_path__ + "static/media/text_size.a33b3178439b2fb6b333cde897aad32b.svg";
export { ForwardRef as ReactComponent };